// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import SystemNewEditForm from '../system-new-edit-form';

// ----------------------------------------------------------------------

export default function SystemCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="System Settings"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'System Settings',
            href: paths.dashboard.system.root,
          },
          { name: 'Products Feilds' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <SystemNewEditForm />
    </Container>
  );
}
